import { ref } from '#imports'

export type ApiStatus = {
  isLoading: boolean
  // Can only be used with useXmlHttp as fetch doesn't support progress
  xhrProgress: number
  response: {
    code: number | null
    status: string | null
    message: string | null
    error: string | null
  }
}

// Used to help show loading status, response status, and error messages in a consistent way across all API calls
export function useApiStatus() {
  return ref<ApiStatus>({
    isLoading: false,
    xhrProgress: 0,
    response: {
      code: null,
      status: null,
      message: null,
      error: null,
    },
  })
}
